import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/accessRequests';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';

//Synchronous

//Asynchronous
export const createAccessRequest = (accessData, callback) => {
    // const newUserData = {
    //     name: userData.name,
    //     username: userData.username,
    //     email_personal: userData.emailPessoal,
    //     email_institutional: userData.emailInstitucional,
    //     phone: userData.telefoneFixo,
    //     cellphone: userData.telefoneCelular,
    //     password: userData.password,
    //     role: userData.role
    // }
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.post(serverRoutes.AccessRequest.crud(), accessData)
        .then((response) => {
            dispatch({
                type: Types.CREATE_ACCESS_REQUEST,
                payload: response.data
            });
            callback(true);
        })
        .catch((err) => {
            toast.error(`Erro: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 });
            callback();
        })
    }
}

// export const updateAccessRequest = (username, userData, callback) => {
//     const newUserData = {
//         name: userData.name,
//         username: userData.username,
//         email_personal: userData.emailPessoal,
//         email_institutional: userData.emailInstitucional,
//         phone: userData.telefoneFixo,
//         cellphone: userData.telefoneCelular,
//         password: userData.password,
//         role: userData.role
//     }
//     return (dispatch) => {
//         axiosInstance.put(serverRoutes.AccessRequest.crud(`/${username}`), newUserData)
//         .then((response) => {
//             dispatch({
//                 type: Types.UPDATE_ACCESS_REQUEST,
//                 payload: response.data
//             })
//             callback(true)
//         })
//         .catch((err) => {
//             callback(false)
//             console.log(err)
//         })
//     }
// }

export const getAccessRequest = (id) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.AccessRequest.crud(`/${id}`))
        .then((response) => {
            dispatch({
                type: Types.GET_ACCESS_REQUEST,
                payload: response.data
            })
        })
        .catch((err) => {
            console.log(err)
            toast.error(`Erro ao buscar pelo pedido de acesso: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 });
            dispatch({
                type: Types.GET_ACCESS_REQUEST,
                payload: null,
            });
        })
    }
}

export const getAllAccessRequests = (page, limit, query, sort="") => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.AccessRequest.crud('', {page, limit, query, sort}))
        .then((response) => {
            dispatch({
                type: Types.GET_ACCESS_REQUESTS,
                payload: response.data
            });
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_ACCESS_REQUESTS,
                payload: []
            });
        })
    }
}

export const getAllAccessRequestsFromUser = (username, page="", limit="", query="", sort="") => {
  if (!username) {
    return () => {}
  }
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.get(serverRoutes.AccessRequest.crudUsername(`/${username}`, {page, limit, query, sort}))
        .then((response) => {
            dispatch({
                type: Types.GET_ACCESS_REQUESTS,
                payload: response.data
            });
        })
        .catch((err) => {
            console.log(err)
            dispatch({
                type: Types.GET_ACCESS_REQUESTS,
                payload: []
            });
        })
    }
}

export const giveAccessRequest = (accessRequestId, body ,query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.post(serverRoutes.AccessRequest.giveAccess(`/${accessRequestId}`, query), body)
        .then((response) => {
            dispatch({
                type: Types.GIVE_ACCESS_REQUEST,
                payload: response.data
            })
            toast.success('Acesso concedido com sucesso!', { autoClose: 10000 })
            callback();
        })
        .catch((err) => {
            console.log(err, err?.request, err?.response)
            toast.error(`Erro ao conceder acesso: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 })
            dispatch({
                type: Types.GIVE_ACCESS_REQUEST,
            })
        })
    }
}

export const denyAccessRequest = (accessRequestId, body ,query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.post(serverRoutes.AccessRequest.denyAccess(`/${accessRequestId}`, query), body)
        .then((response) => {
            dispatch({
                type: Types.DENY_ACCESS_REQUEST,
                payload: response.data
            })
            toast.success('Pedido negado com sucesso!', { autoClose: 10000 });
            callback();
        })
        .catch((err) => {
            console.log(err)
            toast.error(`Erro durante negação do pedido: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 });
            dispatch({
                type: Types.DENY_ACCESS_REQUEST,
                payload: []
            })
        })
    }
}

export const removeAccessRequest = (accessRequestId, body ,query, callback) => {
    return (dispatch) => {
        dispatch({
            type: Types.SET_LOADING
        });
        axiosInstance.post(serverRoutes.AccessRequest.removeAccess(`/${accessRequestId}`, query), body)
        .then((response) => {
            dispatch({
                type: Types.REMOVE_ACCESS_REQUEST,
                payload: response.data
            });
            toast.success('Pedido removido com sucesso!', { autoClose: 10000 });
            callback();
        })
        .catch((err) => {
            console.log(err)
            toast.error(`Erro durante remoção do pedido: ${(err.response?.data?.error || err.response?.data || err.request?.responseText) || err.message}`, { autoClose: 10000 })
            dispatch({
                type: Types.REMOVE_ACCESS_REQUEST,
                payload: [],
            })
        })
    }
}
